module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-detail"
  }, [_c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("水源地全称")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v(_vm._s(_vm.orgdetail.name))])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("水源地地址")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_c('span', {
    staticClass: "form-registry"
  }, [_vm._v(_vm._s(_vm.orgdetail.provinceName))]), _vm._v(" "), _c('span', {
    staticClass: "form-registry"
  }, [_vm._v(_vm._s(_vm.orgdetail.cityName))]), _vm._v(" "), _c('span', {
    staticClass: "form-registry"
  }, [_vm._v(_vm._s(_vm.orgdetail.countyName))]), _vm._v(" "), _c('span', {
    staticClass: "form-registry"
  }, [_vm._v(_vm._s(_vm.orgdetail.address))])])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("保护级别")]), _vm._v(" "), (_vm.orgdetail.subType == 1) ? _c('span', {
    staticClass: "form-rt"
  }, [_vm._v("一级保护区")]) : _vm._e(), _vm._v(" "), (_vm.orgdetail.subType == 2) ? _c('span', {
    staticClass: "form-rt"
  }, [_vm._v("二级保护区")]) : _vm._e(), _vm._v(" "), (_vm.orgdetail.subType == 3) ? _c('span', {
    staticClass: "form-rt"
  }, [_vm._v("准保护区")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("联系人")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v(_vm._s(_vm.orgdetail.linkMan))])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v(_vm._s(_vm.orgdetail.phone))])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("中心坐标")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, [_vm._v("东经：" + _vm._s(_vm._f("formatDegree")(_vm.orgdetail.longitude)) + "，北纬：" + _vm._s(_vm._f("formatDegree")(_vm.orgdetail.latitude)))])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('span', {
    staticClass: "form-lt"
  }, [_vm._v("所属区划")]), _vm._v(" "), _c('span', {
    staticClass: "form-rt"
  }, _vm._l((_vm.orgdetail.regions), function(m) {
    return _c('p', {
      key: m.id
    }, [_c('span', {
      staticClass: "form-registry"
    }, [_vm._v(_vm._s(m.city.name))]), _vm._v(" "), _vm._l((m.county), function(n) {
      return _c('span', {
        key: n.id,
        staticClass: "form-registry"
      }, [_vm._v(_vm._s(n.name))])
    })], 2)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7907dc5d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/burst/Wtdetail.vue
// module id = 1253
// module chunks = 2